// extracted by mini-css-extract-plugin
var _1 = "IconChevron-modulechevronIcon__IVg7u";
var _2 = "IconChevron-moduledown__kkLsw";
var _3 = "IconChevron-moduleleft__qqACU";
var _4 = "IconChevron-moduleright__FoMQ8";
var _5 = "IconChevron-moduleup__fdZbh";
export { _1 as "chevronIcon", _2 as "down", _3 as "left", _4 as "right", _5 as "up" }
